import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import CustomisedButton from '../../../../../components/button/button';
import TemplateLoanCard from '../../../../../components/card/loanCard/TemplateLoanCard';
import StoreCard from '../../../../../components/card/Store/StoreCard';
import FilterButton from '../../../../../components/filter/FilterButton';
import ElementTitle from '../../../../../components/title/elementTitle/elementTitle';
import {IGetLoanTemplatesResponse} from '../../../../../models/loan.model';
import {
    IGetLoanTemplateCategoriesResponse,
    IGetLoanTemplateStoresResponse,
    Store,
} from '../../../../../models/store.model';
import {
    changeRouteType,
    getNextInnerState,
    getNextState,
    getpervInnerState,
} from '../../../../../redux/handleBackBtn/handleBackBtnSlice';
import {
    setHeaderTitle,
    setPageData,
} from '../../../../../redux/headerTitle/headerTitleSlice';
import {GetLoanTemplates} from '../../../../../services/loan.service';
import {
    GetLoanTemplateCategories,
    GetLoanTemplateStores,
} from '../../../../../services/store.service';
import StoreCardSkeleton from '../../../../../components/card/Store/StoreCardSkeleton';
import LoanTemplateDetailSkeleton from './LoanTemplateDetailSkeleton';
import {getpervStateTab} from '../../../../../redux/loansTab/loansTabSlice';

const LoanTemplateDetail = ({
    setInnerState,
    loanTemplateKey,
    setTabChild,
}: {
    setInnerState: any;
    loanTemplateKey: string;
    setTabChild?: any;
}) => {
    const [loanTemplateCategories, setLoanTemplateCategories] = useState<
        IGetLoanTemplateCategoriesResponse[]
    >([]);
    const [loanTemplates, setLoanTemplates] = useState<
        IGetLoanTemplatesResponse[]
    >([]);
    const [stores, setStores] =
        useState<Array<Store & {description: string}>>();
    const [selectedId, setSelectedId] = useState<number | undefined>(undefined);
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const {
        mutate: GetLoanTemplatesCategoriesMutate,
        isLoading: isLoadingCategories,
    } = useMutation(GetLoanTemplateCategories, {
        onSuccess: (data: IGetLoanTemplateCategoriesResponse[]) => {
            if (data) {
                setLoanTemplateCategories([
                    {
                        title: 'همه',
                        id: undefined,
                        colorCode: '',
                        logoUrl: '',
                        subCategories: [],
                        sortIndex: 0,
                        englishTitle: '',
                    },
                    ...data,
                ]);
            }
        },
        onError: () => {},
    });
    const {mutate: GetLoanTemplateStoresMutate, isLoading: isLoadingStores} =
        useMutation(GetLoanTemplateStores, {
            onSuccess: (data: IGetLoanTemplateStoresResponse) => {
                if (data) {
                    setStores(
                        mergeStores(data.offlineStores, data.onlineStores)
                    );
                }
            },
            onError: () => {},
        });
    const {mutate: GetLoanTemplatesMutate, isLoading: isLoadingLoanTemplates} =
        useMutation(GetLoanTemplates, {
            onSuccess: (data: IGetLoanTemplatesResponse[]) => {
                if (data) {
                    setLoanTemplates(data);
                }
            },
            onError: () => {},
        });

    function mergeStores(offline: Store[], online: Store[]) {
        const offlineMap = new Map(offline.map((s) => [s.id, s]));
        const onlineMap = new Map(online.map((s) => [s.id, s]));

        const result: Array<Store & {description: string}> = [];

        // offline + both
        offline.forEach((store) => {
            const inOnline = onlineMap.has(store.id);
            result.push({
                ...store,
                description: inOnline ? 'حضوری/آنلاین' : 'حضوری',
            });
        });

        // online only
        online.forEach((store) => {
            if (!offlineMap.has(store.id)) {
                result.push({
                    ...store,
                    description: 'آنلاین',
                });
            }
        });

        return result;
    }

    const handleSelectCategory = (id: number | undefined) => {
        GetLoanTemplateStoresMutate({loanTemplateKey, categoryId: id});
        setSelectedId(id);
    };

    const handleStoreDetail = (storeId: number) => {
        setTabChild(1);
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getNextInnerState({nextInnerState: `sellerInfo  ${Math.random()}`})
        );
        dispatch(setPageData({page: 'sellers', id: String(storeId)}));
    };

    useEffect(() => {
        GetLoanTemplatesMutate({
            loanTemplateKey:
                loanTemplateKey ||
                queryClient.getQueryData('LOAN_TEMPLATE_KEY'),
        });
        GetLoanTemplatesCategoriesMutate({loanTemplateKey, loadLogo: false});
        GetLoanTemplateStoresMutate({loanTemplateKey});
        dispatch(
            setHeaderTitle({
                header: 'مشخصات تسهیلات',
                color: 'var(--header-color)',
                parentRoute: '',
            })
        );
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({
                prevInnerState: `selectLoanTemplate ${Math.random()}`,
            })
        );
    }, []);

    const selectedIndex =
        selectedId === undefined
            ? 0
            : loanTemplateCategories.findIndex((cat) => cat.id === selectedId);

    if (isLoadingLoanTemplates || isLoadingCategories) {
        return <LoanTemplateDetailSkeleton />;
    }
    return (
        <div
            style={{
                height: 'calc(100svh - 60px)',
                paddingInline: '20px',
                overflowY: 'auto',
                paddingTop: '15px',
                paddingBottom: '60px',
            }}
        >
            <TemplateLoanCard
                description={loanTemplates[0]?.description}
                title={loanTemplates[0]?.title}
                logo={loanTemplates[0]?.logoUrl}
            />
            <div className="py-5 w-full" style={{paddingTop: '20px'}}>
                <CustomisedButton
                    title={'ثبت درخواست تسهیلات'}
                    disable={false}
                    onClick={() => {
                        setInnerState('createNewRequest');
                    }}
                    type="submit"
                />
            </div>

            {stores && stores?.length > 0 && (
                <ElementTitle title={'فروشگاه‌های طرف قرارداد'} />
            )}

            <div
                className="py-5 w-full flex gap-2 overflow-x-auto"
                style={{paddingTop: '20px'}}
            >
                {loanTemplateCategories?.map((item, index) => (
                    <FilterButton
                        title={item.title}
                        isActive={selectedIndex === index}
                        onClick={() => handleSelectCategory(item.id)}
                    />
                ))}
            </div>

            {!isLoadingStores ? (
                <div className="flex flex-col gap-4">
                    {stores?.map((item, index) => (
                        <StoreCard
                            key={index}
                            description={item.description}
                            title={item.title}
                            logo={item.logoUrl}
                            onClick={() => handleStoreDetail(item.id)}
                        />
                    ))}
                </div>
            ) : (
                <StoreCardSkeleton />
            )}
        </div>
    );
};

export default LoanTemplateDetail;
